import React, { useState ,useEffect } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { useForm } from 'react-hook-form';
import { CountryDropdown} from 'react-country-region-selector';
import CardSection from './CardSection';

export default function CheckoutForm(props) {
    const stripe = useStripe();
    const elements = useElements();
  
    const nullCard = {      
        year: null,
        last4:""

    }
    const [stripeIdState, setStripeIdState] = useState("");
    const [cardState, setCardState] = useState(nullCard);
    const [message, setMessage] = useState('');
    const [countryDisplay, setCountryDisplay] = useState('');
   
    useEffect( () => {     
        async function getAcc() {
            const resp = await fetch('api/billing/getaccount', {
                method: 'GET',
                credentials: 'same-origin'
            })
            if (resp.status === 200) {

                const jdata = await resp.json();
                //console.log(jdata);
                setStripeIdState(jdata.stripeId);
                setCardState(jdata.card);
            }
            else if (resp.status === 401) {
                setMessage('401: Not Authorized');
                
            }
            else if (resp.status === 400) {
                setMessage('There was an error in getting account info.');
               
            }             
        };
        if (stripeIdState === "") {
            getAcc();
        }
       
    });
    const { register, handleSubmit } = useForm();
    const submitStripe = async (data) => {
     
        props.showBusy(true);
       // event.preventDefault();
    
        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }
        
        let formAddress = {
            "city": data.city,           
            "country": countryDisplay,
            "line1": data.line1,
            "line2": data.line2,
            "postal_code": data.postal_code,
            "state": data.state
        };
       
        const result = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
           
            billing_details: {                
                name: data.name,
                email: data.email,
                address:formAddress
                
            },
        });
        //console.dir(result);
      
        await stripePaymentMethodHandler(result);
    
    };
   
    async function stripePaymentMethodHandler(result) {
        if (result.error) {
            //console.log(result.error);
            setMessage(result.error.message);
        }
        else {
          
            const resp = await fetch('api/billing/savepaymentmethod', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    accountid: stripeIdState,
                    payment_method: result.paymentMethod.id
                }),
            })
            if (resp.status === 200) {
           
                props.success();
            }

            else if (resp.status === 401 || resp.status === 402) {
                //var retData = await resp.json();
                //console.log(retData);
                setMessage('Card was declined. Please check card details or try a different card.' );              
            }
            else if (resp.status === 400 || resp.status === 500) {
                setMessage('There was an error in setting payment.Please contact us.');   
            }
        }       
    }

    const cancel = props.hasPayment ? (<div className="pull-right">
        <button type="button" className="btn btn-danger  mt20" onClick={props.success} >Cancel </button>
    </div>) : "";


    const currentCardDetail = !!cardState.last4 ? (<div>Current Card: Exp. Year {cardState.year} Last 4 {cardState.last4} </div>):""
    const msg = !!message ? (<div className="alert alert-danger mt-2"> {message} </div>) : "";
   
    
return (

    <div>
        <form onSubmit={handleSubmit(submitStripe)} className="mt20 ">

            {currentCardDetail}
            <hr />
            <h3>Card Holder Details </h3>
            <div >
                <div className="form-group row">
                    <label htmlFor="Name" className="col-sm-2 control-label">Name</label>
                    <div className="col-sm-10">
                        <input ref={register} type="text" className="form-control" name="name" id="nametext" required />
                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <div className="form-group row">
                    <label htmlFor="Email" className="col-sm-2 control-label">Email</label>
                    <div className="col-sm-10">
                        <input ref={register} type="text" className="form-control" name="email" id="emailtext" required />
                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <h3>Billing Address </h3>
                <div className="form-group row">
                    <label htmlFor="line1" className="col-sm-2 control-label">Address</label>
                    <div className="col-sm-10">
                        <input ref={register} type="text" className="form-control" name="line1" id="line1text" required />
                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <div className="form-group row">
                    <label htmlFor="line2" className="col-sm-2 control-label"> Address Line 2</label>
                    <div className="col-sm-10">
                        <input ref={register} type="text" className="form-control" name="line2" id="line2text" />
                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <div className="form-group row">
                    <label htmlFor="city" className="col-sm-2 control-label">City</label>
                    <div className="col-sm-10">
                        <input ref={register} type="text" className="form-control" name="city" id="citytext" required />
                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <div className="form-group row">
                    <label htmlFor="country" className="col-sm-2 control-label">Country</label>
                    <div className="col-sm-10">
                        <CountryDropdown type="text" className="form-control" name="country" id="countrytext" value={countryDisplay}
                            onChange={(val) => setCountryDisplay(val)} valueType="short" required />

                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <div className="form-group row">
                    <label htmlFor="state" className="col-sm-2 control-label">State</label>
                    <div className="col-sm-10">
                        <input ref={register} type="text" className="form-control" name="state" id="statetext" required />
                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <div className="form-group row">
                    <label htmlFor="postal_code" className="col-sm-2 control-label">Postal Code</label>
                    <div className="col-sm-10">
                        <input ref={register} type="text" className="form-control" name="postal_code" id="postal_codetext" required />
                    </div>
                    <input type="hidden" name="icon" className="item-menu" />
                </div>
                <CardSection />
            </div>

            <div>

                <button className="btn btn-primary mt20" disabled={!stripe}>Confirm Payment Info</button>

                {cancel}
         


            </div>
        
            {msg}
        
        </form>
        <p className="alert alert-danger mt20">
            Gstitch cannot refund or prorate funds acquired by Stripe transactions. Any credits are held by Stripe and applied to future Stripe purchases.

</p>
    </div>
);
}

